import AccessControlCreateEdit from '../pages/MasterData/AccessControl/AccessControlCreateEdit';
import AccessControlView from '../pages/MasterData/AccessControl/AccessControlView';
import AimsDocumentTypeCreateEdit from '../pages/MasterData/AimsDocumentType/AimsDocumentTypeCreateEdit';
import AimsDocumentTypeView from '../pages/MasterData/AimsDocumentType/AimsDocumentTypeView';
import ApprovalCodeCreateEdit from '../pages/MasterData/ApprovalCode/ApprovalCodeCreateEdit';
import ApprovalCodeView from '../pages/MasterData/ApprovalCode/ApprovalCodeView';
import ApprovalTypeCreateEdit from '../pages/MasterData/ApprovalType/ApprovalTypeCreateEdit';
import ApprovalTypeView from '../pages/MasterData/ApprovalType/ApprovalTypeView';
import ContractorCreateEdit from '../pages/MasterData/Contractor/ContractorCreateEdit';
import ContractorView from '../pages/MasterData/Contractor/ContractorView';
import DisciplineCreateEdit from '../pages/MasterData/Discipline/DisciplineCreateEdit';
import DisciplineView from '../pages/MasterData/Discipline/DisciplineView';
import DocumentCreateEdit from '../pages/MasterData/Document/DocumentCreateEdit';
import DocumentView from '../pages/MasterData/Document/DocumentView';
import DocumentGroupCreateEdit from '../pages/MasterData/DocumentGroup/DocumentGroupCreateEdit';
import DocumentGroupView from '../pages/MasterData/DocumentGroup/DocumentGroupView';
import PurposeCreateEdit from '../pages/MasterData/Purpose/PurposeCreateEdit';
import PurposeView from '../pages/MasterData/Purpose/PurposeView';
import RevisionCreateEdit from '../pages/MasterData/Revision/RevisionCreateEdit';
import RevisionView from '../pages/MasterData/Revision/RevisionView';
import WorkflowCreateEdit from '../pages/MasterData/Workflow/WorkflowCreateEdit';
import WorkflowView from '../pages/MasterData/Workflow/WorkflowView';
import WorkflowStatusCreateEdit from '../pages/MasterData/WorkflowStatus/WorkflowStatusCreateEdit';
import WorkflowStatusView from '../pages/MasterData/WorkflowStatus/WorkflowStatusView';
import WorkflowStepCreateEdit from '../pages/MasterData/WorkflowStep/WorkflowStepCreateEdit';
import WorkflowStepView from '../pages/MasterData/WorkflowStep/WorkflowStepView';

export const getMasterData = (t: (key: string) => string) => [
  {
    text: t('masterData.items.accessControl'),
    url: '/access-controls',
    component: AccessControlView
  },
  {
    text: t('masterData.items.aimsDocumentType'),
    url: '/aims-document-types',
    component: AimsDocumentTypeView
  },
  {
    text: t('masterData.items.approvalCode'),
    url: '/approval-codes',
    component: ApprovalCodeView
  },
  {
    text: t('masterData.items.approvalType'),
    url: '/approval-types',
    component: ApprovalTypeView
  },
  {
    text: t('masterData.items.contractor'),
    url: '/contractors',
    component: ContractorView
  },
  {
    text: t('masterData.items.discipline'),
    url: '/disciplines',
    component: DisciplineView
  },
  {
    text: t('masterData.items.document'),
    url: '/documents',
    component: DocumentView
  },
  {
    text: t('masterData.items.documentGroup'),
    url: '/document-groups',
    component: DocumentGroupView
  },
  {
    text: t('masterData.items.purpose'),
    url: '/purposes',
    component: PurposeView
  },
  {
    text: t('masterData.items.revision'),
    url: '/revisions',
    component: RevisionView
  },
  {
    text: t('masterData.items.workflow'),
    url: '/workflows',
    component: WorkflowView
  },
  {
    text: t('masterData.items.workflowStatus'),
    url: '/workflow-statuses',
    component: WorkflowStatusView
  },
  {
    text: t('masterData.items.workflowStep'),
    url: '/workflow-steps',
    component: WorkflowStepView
  }
];

export const getMasterDataRoute = (t: (key: string) => string) => [
  ...getMasterData(t),
  {
    text: t('masterData.items.accessControl'),
    url: '/access-controls/create',
    component: AccessControlCreateEdit
  },
  {
    text: t('masterData.items.accessControl'),
    url: '/access-controls/:accessControlId/edit',
    component: AccessControlCreateEdit
  },
  {
    text: t('masterData.items.aimsDocumentType'),
    url: '/aims-document-types/create',
    component: AimsDocumentTypeCreateEdit
  },
  {
    text: t('masterData.items.aimsDocumentType'),
    url: '/aims-document-types/:aimsDocumentTypeId/edit',
    component: AimsDocumentTypeCreateEdit
  },
  {
    text: t('masterData.items.approvalCode'),
    url: '/approval-codes/create',
    component: ApprovalCodeCreateEdit
  },
  {
    text: t('masterData.items.approvalCode'),
    url: '/approval-codes/:approvalCodeId/edit',
    component: ApprovalCodeCreateEdit
  },
  {
    text: t('masterData.items.approvalType'),
    url: '/approval-types/create',
    component: ApprovalTypeCreateEdit
  },
  {
    text: t('masterData.items.approvalType'),
    url: '/approval-types/:approvalTypeId/edit',
    component: ApprovalTypeCreateEdit
  },
  {
    text: t('masterData.items.contractor'),
    url: '/contractors/create',
    component: ContractorCreateEdit
  },
  {
    text: t('masterData.items.contractor'),
    url: '/contractors/:contractorId/edit',
    component: ContractorCreateEdit
  },
  {
    text: t('masterData.items.discipline'),
    url: '/disciplines/create',
    component: DisciplineCreateEdit
  },
  {
    text: t('masterData.items.discipline'),
    url: '/disciplines/:disciplineId/edit',
    component: DisciplineCreateEdit
  },
  {
    text: t('masterData.items.document'),
    url: '/documents/create',
    component: DocumentCreateEdit
  },
  {
    text: t('masterData.items.document'),
    url: '/documents/:documentId/edit',
    component: DocumentCreateEdit
  },
  {
    text: t('masterData.items.documentGroup'),
    url: '/document-groups/create',
    component: DocumentGroupCreateEdit
  },
  {
    text: t('masterData.items.documentGroup'),
    url: '/document-groups/:documentGroupId/edit',
    component: DocumentGroupCreateEdit
  },
  {
    text: t('masterData.items.purpose'),
    url: '/purposes/create',
    component: PurposeCreateEdit
  },
  {
    text: t('masterData.items.purpose'),
    url: '/purposes/:purposeId/edit',
    component: PurposeCreateEdit
  },
  {
    text: t('masterData.items.revision'),
    url: '/revisions/create',
    component: RevisionCreateEdit
  },
  {
    text: t('masterData.items.revision'),
    url: '/revisions/:revisionId/edit',
    component: RevisionCreateEdit
  },
  {
    text: t('masterData.items.workflow'),
    url: '/workflows/create',
    component: WorkflowCreateEdit
  },
  {
    text: t('masterData.items.workflow'),
    url: '/workflows/:workflowId/edit',
    component: WorkflowCreateEdit
  },
  {
    text: t('masterData.items.workflowStatus'),
    url: '/workflow-statuses/create',
    component: WorkflowStatusCreateEdit
  },
  {
    text: t('masterData.items.workflowStatus'),
    url: '/workflow-statuses/:workflowStatusId/edit',
    component: WorkflowStatusCreateEdit
  },
  {
    text: t('masterData.items.workflowStep'),
    url: '/workflow-steps/create',
    component: WorkflowStepCreateEdit
  },
  {
    text: t('masterData.items.workflowStep'),
    url: '/workflow-steps/:workflowStepId/edit',
    component: WorkflowStepCreateEdit
  }
];
